import { render, staticRenderFns } from "./teacherLogin.vue?vue&type=template&id=4fd9282f&scoped=true&"
import script from "./teacherLogin.vue?vue&type=script&lang=js&"
export * from "./teacherLogin.vue?vue&type=script&lang=js&"
import style0 from "./teacherLogin.vue?vue&type=style&index=0&id=4fd9282f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9282f",
  null
  
)

export default component.exports